import { ranking } from '@/mocks/comic';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-secondary-600',
  down: 'ri-arrow-down-line text-primary-500',
  flat: 'ri-subtract-line text-foreground-400',
};

export default function Ranking() {
  return (
    <section id="rank" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              人气排行
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black text-foreground-900 md:text-4xl">
              本周最热讨论话题
            </h2>
            <p className="mt-3 max-w-2xl text-base text-foreground-700">
              大家都在聊什么？按热度快速浏览最近最值得参与的剧情讨论。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-foreground-600 ring-1 ring-background-300/70 whitespace-nowrap">
            <i className="ri-refresh-line" />
            每小时更新
          </span>
        </div>

        <div className="mt-10 overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70">
          {ranking.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-6 ${
                idx !== ranking.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base font-black ${
                  item.rank <= 3 ? 'bg-accent-500 text-foreground-950' : 'bg-background-100 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-900 md:text-base">{item.title}</h3>
                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">热度 {item.heat}</span>
                </div>
              </div>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                <i className={`${trendIcon[item.trend]} text-base`} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}